import styled from '@emotion/styled'

import { Image } from '@/components/Image'

import { HeadingL, HeadingXS } from '@/components/Typography'
import { withContainer } from '@/hocs/withContainer'
import { CONFIG } from '@/styles/emotion.config'

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-bottom: 1.5rem;
`

export const Title = styled(withContainer(HeadingL))`
  ${CONFIG.media.lg} {
    font-size: 3rem;
  }
`

export const Subtitle = styled(withContainer(HeadingXS))`
  font-weight: normal;
`

export const HeroImage = styled(withContainer(Image))`
  padding-top: 1.5rem;
  border-radius: ${CONFIG.theme.radii.sm};
`
